import React from 'react'
import styled from 'styled-components'

const BREAKPOINTS = {
  desktop: 1680,
  laptop: 1072,
  tablet: 711,
  mobile: 0,
}

const cols = {
  normal: { mobile: '1/3', tablet: '1/9', laptop: '3/11', desktop: '4/10' },
  wide: { mobile: '1/-1', tablet: '1/-1', laptop: '1/-1', desktop: '1/-1' },
  left: { mobile: '1/3', tablet: '1/5', laptop: '1/7', desktop: '1/7' },
  right: { mobile: '1/3', tablet: '5/9', laptop: '7/13', desktop: '7/13' },
}
const getCols = (columnType: 'left' | 'right' | 'wide' | undefined) =>
  columnType
    ? columnType === 'wide'
      ? 'wide'
      : columnType === 'left'
      ? 'left'
      : 'right'
    : 'normal'

const _Column = styled.div<{
  columnType: 'left' | 'right' | 'wide' | undefined
}>`
  p:first-of-type {
    margin-top: 0;
  }
  @media only screen and (min-width: ${BREAKPOINTS.mobile}px) {
    grid-column: ${(props) => cols[getCols(props.columnType)].mobile};
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
    grid-column: ${(props) => cols[getCols(props.columnType)].tablet};
  }
  @media only screen and (min-width: ${BREAKPOINTS.laptop}px) {
    grid-column: ${(props) => cols[getCols(props.columnType)].laptop};
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}px) {
    grid-column: ${(props) => cols[getCols(props.columnType)].desktop};
  }
`

export const Column: React.FunctionComponent<{
  /** toggles two columns and sets column side to left */
  left?: boolean
  /** toggles two columns and sets column side to right */
  right?: boolean
  /** sets the column to use all grid columns on all breakpoints */
  wide?: boolean
  /** styling via css class */
  className?: string
  /** styling via inline css */
  style?: React.CSSProperties
  children: string | JSX.Element | JSX.Element[]
}> = ({
  children,
  left = false,
  right = false,
  wide = false,
  className,
  style,
}) => (
  <_Column
    className={className}
    columnType={wide ? 'wide' : left ? 'left' : right ? 'right' : undefined}
    style={style}
  >
    {children}
  </_Column>
)
